RivalIQ.apps.Dashboard.module('curations.filters', function (filters, App, Backbone, Marionette, $, _) {

    'use strict';

    filters.ChannelFilterFactory = function (options) {
        return function (curation) {
            return filters.channelWall(curation, options.channel, options);
        };
    };

    function buildWall(curation, source, options) {
        curation.setProps('channelRedacted', true, {
            silent: true
        });
        if (curation.isExporting()) {
            RivalIQ.export.failExport('channel redacted');
        }
        return new RivalIQ.channels.views.ChannelWall({
            source: source,
            template: options.template,
            size: options.size,
            isExport: curation.isExporting(),
            wallType: options.wallType
        });
    }

    filters.channelWall = function (curation, channelOverride, options) {

        const channel = RivalIQ.data.channels.get(channelOverride || curation.getProp('channel'));
        options = _.defaults(options || {}, {
            size: 'large'
        });

        // NOTE this redirects if the channel is hidden
        if (RivalIQ.channels.enforceHiddenChannel(channel.id)) {
            return new Backbone.View();
        }

        // Do this check before the curation.presence check as it's possible that users have a presence from a previous
        // life on a plan that had access to this source but are now on a source that doesn't support this.
        if (!RivalIQ.props.channelSupported(curation.getProps(), channel.get('source'))) {
            options.template = options.upsellTemplate;
            options.wallType = 'upsell';
            return buildWall(curation, channel.id, options);
        }

        if (curation.presence) {
            return false;
        }

        if (!channel.validCredentialsRequired()) {
            return false;
        }

        return RivalIQ.state.account.fetch().then(function () {

            if (RivalIQ.props.channelRedacted(curation.getProps(), channel.get('source'))) {
                return buildWall(curation, channel.id, options);
            }

            return false;
        });
    };

    filters.privateDataFeatureAccess = function (source, options) {
        const betaRequired = _.get(options, 'betaRequired');
        return function (curation) {
            if (betaRequired && !RivalIQ.state.account.inBeta(betaRequired)) {
                return RivalIQ.state.product.get('defaultRedirectLocation');
            }

            const sourceDetails = RivalIQ.enums.sourceDetails[source];

            const props = _.extend({
                channel: sourceDetails.channel
            }, curation.getProps());
            return RivalIQ.data.privateMetadata.fetch(props, {
                force: true
            }).then(function (metadata) {
                if (!_.get(metadata, ['sources', source, 'validToken'])) {
                    return buildWall(curation, source, _.extend({
                        size: 'large'
                    }, options));
                }

                curation.setProps('channelRedacted', null, {
                    silent: true
                });
            });
        };
    };
});
